<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" labelAlign="right">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24" v-if="!tenantFirmId && userType !== 1">
              <a-form-item label="企业品牌">
                <Province @province="handleProvince" ref="province"></Province>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="userType == 2">
              <a-form-item label="经销商">
                <a-select
                  show-search
                  v-model="queryParam.tenantAgentId"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  allowClear
                >
                  <a-select-option v-for="d in userList" :key="d.id">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="产品名称">
                <a-select
                  show-search
                  v-model="queryParam.id"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  @change="handleChangeModel"
                  allowClear
                >
                  <a-select-option v-for="d in ModeLlist" :key="d.id">{{ d.productName }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="规格名称">
                <a-select
                  show-search
                  v-model="queryParam.caliberId"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  @change="handleChangeCaliber"
                  allowClear
                >
                  <a-select-option v-for="d in modelCalibers" :key="d.id">{{ d.code }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="属性名称">
                <a-select
                  show-search
                  v-model="queryParam.attributeId"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  allowClear
                >
                  <a-select-option v-for="d in attributeOption" :key="d.id">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- <a-col :md="6" :sm="24"  >
              <a-form-item label="属性名称" >
                <a-select
                  show-search
                  v-model="queryParam.tenantAgentId"
                  placeholder="请选择"
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option v-for="d in userList" :key="d.id">{{ d.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
            <a-col :md="(!advanced && 6) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="(advanced && { float: 'right', overflow: 'hidden' }) || {}"
              >
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
                <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? '收起' : '展开' }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a> -->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        :userList="userList"
        :statusOptions="dict.type['sys_enable_disable']"
        @ok="getList"
      />
      <DevCan ref="DevCan"></DevCan>
      <!-- 批量导入 -->
      <UploadAdd ref="uploadAdd" @ok="getList"></UploadAdd>
      <div class="table-operations">
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="status" slot-scope="text, record">
          <dict-tag :options="dict.type['sys_enable_disable']" :value="record.status" />
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="count" slot-scope="text, record"> {{ record.count }}{{ record.unit }} </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['abm-fix:dev:edit']"> 修改 </a>
          <a-divider type="vertical" v-hasPermi="['abm-fix:dev:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['abm-fix:dev:remove']"> 删除 </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { fetchList, delObj, fetchPublic } from '@/api/pressure/goodStatistics'
import { listTenant } from '@/api/system/tenant'
import CreateForm from './modules/CreateForm'
import DevCan from './modules/devCan'
import Province from '@/components/formModel/Province'
import { tableMixin } from '@/store/table-mixin'
// import UploadAdd from './modules/uploadAdd'
// import Parameter from '../../pressure/parameter'
import UploadAdd from '../../system/tenant/modules/uploadAdd.vue'
import { publicModel } from '@/api/pressure/mode'

import { mapGetters } from 'vuex'
export default {
  name: 'Post',
  components: {
    CreateForm,
    UploadAdd,
    DevCan,
    Province,
  },
  mixins: [tableMixin],
  dicts: ['sys_enable_disable'],
  props: {
    isOperate: {
      type: Boolean,
      default: true,
    },
    tenantFirmId: {
      type: [String, Number],
    },
    tenantId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      list: [],
      userList: [],
      selectedRowKeys: [],
      selectedRows: [],
      ModeLlist: [],
      modelCalibers: [],
      attributeOption: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
        caliberId: undefined,
        attributeId: undefined,
        id: undefined,
      },
      columns: [
        {
          title: '产品名称',
          dataIndex: 'name',
          width: '200px',
          align: 'center',
        },
        {
          title: '规格名称',
          dataIndex: 'caliberName',
          align: 'center',
        },
        {
          title: '属性名称',
          dataIndex: 'attributeName',
          align: 'center',
        },
        // {
        //   title: '单位',
        //   dataIndex: 'unit',
        //   ellipsis: true,
        //   align: 'center',
        // },
        {
          title: '总数量',
          dataIndex: 'count',
          scopedSlots: { customRender: 'count' },
          ellipsis: true,
          align: 'center',
        },
      ],
    }
  },
  filters: {},
  created() {
    this.getList()
    this.getAgent()
    this.getModel()
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
  },
  watch: {},
  methods: {
    // 查询所有的产品
    getModel() {
      publicModel().then((response) => {
        console.log(response, 'responseresponse')

        this.ModeLlist = response.data.records
        console.log(this.ModeLlist, 'this.ModeLlist ')
      })
    },
    // type
    // 点击批量添加设备
    handleUpload() {
      this.uploadAdd = true
      this.$nextTick(() => {
        this.$refs.uploadAdd.init(3)
      })
    },
    handleProvince(e) {
      this.queryParam.tenantFirmId = e
      this.$forceUpdate()
    },
    // 查询经销商
    getAgent() {
      const query = {
        pageNum: 1,
        pageSize: 999,
        type: 2,
        status: 0,
      }
      listTenant(query).then((res) => {
        console.log(res, '的点点滴滴')
        this.userList = res.data.records
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleChangeModel(e) {
      console.log(e, '的点点滴滴')
      this.ModeLlist.forEach((v) => {
        if (v.id == e) {
          console.log(v, '顶顶顶顶')
          this.modelCalibers = v.modelCalibers
        }
      })

      this.queryParam.caliberId = undefined
      this.$forceUpdate()
    },
    handleChangeCaliber(e) {
      fetchPublic({ modelId: e.id }).then((res) => {
        const data = res.data.records
        data.unshift({ id: 0, name: '标准' })
        this.attributeOption = data
        console.log(data, 'datadata')
      })
    },
    /** 查询部门列表 */
    getList() {
      this.loading = true
      fetchList(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    // 点击确定
    onChange(e) {
      console.log(e, '的点点滴滴')
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        pageNum: 1,
        pageSize: 10,
        postCode: undefined,
        postName: undefined,
        status: undefined,
        caliberId: undefined,
        id: undefined,
      }
      this.handleQuery()
      this.$nextTick(() => {
        this.$refs.province.init()
      })
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      let ids = []
      if (row.id) {
        ids = [row.id]
      } else {
        ids = this.ids
      }
      this.$confirm({
        title: '是否确认删除此数据?',
        onOk() {
          return delObj(ids).then(() => {
            that.onSelectChange([], [])
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel() {},
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk() {
          that.download(
            'fix/dev/export',
            {
              ...that.queryParam,
            },
            `设备信息${new Date().getTime()}.xlsx`
          )
        },
        onCancel() {},
      })
    },
  },
}
</script>
